interface Tag {
  state: TagState;
  text: string;
}

export enum TagState {
  DEACTIVATED = "deactivated",
  ACTIVE = "active",
}

export const Tag = ({ state, text }: Tag) => (
  <span
    className={`ml-2 text-xs items-center  px-1 ${
      state === TagState.ACTIVE ? "bg-tag-1" : "bg-tag-4"
    } text-gray-700 rounded-full`}
  >
    {text}
  </span>
);
